// src/components/ConversationWindow.js

import React, { useEffect, useRef } from 'react';
import BotMessage from './BotMessage';
import UserMessage from './UserMessage';

function ConversationWindow({ history, subtitleMode }) {
  const messagesEndRef = useRef(null);

  // scrollIntoView({ block: 'end' }) on a sentinel child is the reliable
  // mobile approach. Setting scrollTop directly on the flex container itself
  // does not create a touch-scroll context on iOS Safari, so new messages
  // stayed below the fold and the list was not touch-scrollable at all.
  // Using a sentinel child element + scrollIntoView lets the browser handle
  // the scroll natively without interfering with the user's own touch gestures.
  // requestAnimationFrame ensures the new message has been laid out before we
  // measure the scroll target.
  useEffect(() => {
    requestAnimationFrame(() => {
      messagesEndRef.current?.scrollIntoView({ block: 'end', inline: 'nearest' });
    });
  }, [history]);

  return (
    <div className="message-list">
      {history.map((message, index) =>
        message.speaker === 'bot' ? (
          <BotMessage key={index} message={message} subtitleMode={subtitleMode} />
        ) : (
          <UserMessage key={index} message={message} subtitleMode={subtitleMode} />
        )
      )}
      <div ref={messagesEndRef} />
    </div>
  );
}

export default ConversationWindow;
